// İçeri alma önizlemesinin ortak modeli: sunucu kodlarının sınıflandırması, biçimleme, istek gövdesi.
// Sunucu kodları arayüze çıkmaz: her kod bir sınıfa düşer (kullanıcı düzeltir / belge / önceki içeri alma / bilgi / sistem).
import { formatDecimal } from "@/components/QuickImportDialog";

export const FIX = {
  LINE_CLASS_UNRESOLVED: [1, "Ürün mü hizmet mi olduğunu seçin."],
  LINE_CLASS_REQUIRED: [1, "Ürün mü hizmet mi olduğunu seçin."],
  PRODUCT_KIND_REQUIRED: [1, "Ürün mü hizmet mi olduğunu seçin."],
  PRODUCT_NOT_MATCHED: [1, "Bu satır için ürünü seçin ya da hizmet olarak işaretleyin."],
  STOCK_PRODUCT_UNRESOLVED: [1, "Stoğa girmesi için listeden ürünü seçin."],
  PRODUCT_MATCH_AMBIGUOUS: [1, "Birden fazla ürün uyuyor; doğru ürünü seçin."],
  PRODUCT_DRAFT_CANNOT_BE_STOCKED: [1, "Hatırlanacak yeni ürün stoğa alınamaz; mevcut ürünü seçin ya da stok girişini kapatın."],
  CATALOG_DUPLICATE: [1, "Bu ürün katalogda zaten var; listeden mevcut ürünü seçin."],
  PRODUCT_DRAFT_DUPLICATE: [1, "Bu ürün katalogda zaten var; listeden mevcut ürünü seçin."],
  PRODUCT_CHOICE_INVALID: [1, "Seçtiğiniz ürün artık geçerli değil; yeniden seçin."],
  REFERENCE_INVALID: [1, "Seçtiğiniz kayıt artık geçerli değil; yeniden seçin."],
  SUPPLIER_NOT_MATCHED: [0, "Tedarikçiyi seçin."],
  SUPPLIER_MATCH_AMBIGUOUS: [0, "Birden fazla tedarikçi uyuyor; doğru tedarikçiyi seçin."],
  SUPPLIER_CHOICE_INVALID: [0, "Seçilen tedarikçi bu faturaya uymuyor; yeniden seçin."],
  WAREHOUSE_REQUIRED: [1, "Stoğa girecek ürün satırları için depo seçin."],
  WAREHOUSE_INVALID: [1, "Seçilen depo kullanılamıyor; başka bir depo seçin."],
  STOCK_NOT_APPLICABLE: [1, "Stoğa girecek ürün satırı yok; stok girişini kapatın."],
  SOURCE_CHANGED: [0, "Fatura sağlayıcıda güncellendi; pencereyi kapatıp yeniden açın."],
  PREVIEW_EXPIRED: [0, "Önizlemenin süresi doldu; pencereyi kapatıp yeniden açın."],
};

const DOCUMENT = {
  TOTAL_MISMATCH: "Fatura toplamı satırlardan hesaplanan tutarla uyuşmuyor.",
  PROVIDER_TOTAL_MISSING: "Faturada ödenecek toplam yok.",
  TOTALS_INVALID: "Fatura tutarları hesaplanamadı.",
  LINE_TOTAL_MISMATCH: "Satır tutarı miktar × fiyat − iskonto ile uyuşmuyor.",
  LINE_VAT_MISMATCH: "Satırın KDV tutarı faturadakiyle uyuşmuyor.",
  LINE_FIELD_MISSING: "Satırda miktar, fiyat, KDV veya açıklama eksik.",
  LINE_DISCOUNT_UNREADABLE: "Satırdaki iskonto okunamadı.",
  EXEMPTION_REQUIRED: "KDV istisna kodu gerekiyor; bu ekranda girilemez.",
  EXEMPTION_CODE_REQUIRED: "KDV istisna kodu gerekiyor; bu ekranda girilemez.",
  DOCUMENT_NUMBER_REQUIRED: "Faturada numara yok.",
  DOCUMENT_NUMBER_MISSING: "Faturada numara yok.",
  CURRENCY_NOT_SUPPORTED: "Faturanın para birimi bu akışta desteklenmiyor.",
  DOCUMENT_INVALID: "Fatura bu akışla okunamadı.",
  SUPPLIER_DATA_INVALID: "Faturadaki tedarikçi bilgileri eksik veya geçersiz.",
};

// Önceki/süren içeri alma: belge hatası DEĞİL; tedarikçiye yönlendirilmez. Her biri ayrı başlık + ne yapılacağı.
const IMPORT_STATE = {
  // Sunucu kodu kaydın HANGİ defterde olduğunu (çekirdek/eski stok işlemi) ayırmaz: liste adı söylenmez.
  DUPLICATE_DOCUMENT: ["Bu fatura için daha önce oluşturulmuş bir kayıt var.", "Aynı fatura ikinci kez içeri alınamaz."],
  // Kod etkin, durumu bilinmeyen ve geçersiz taslağı birlikte kapsar: "sürüyor" denmez.
  OPEN_IMPORT_EXISTS: ["Bu fatura için daha önce açılmış bir içeri alma kaydı var.", "Bu kaydın durumu netleşmeden fatura yeniden içeri alınamaz."],
  PRIOR_IMPORT_FAILED: ["Bu fatura için önceki içeri alma denemesi tamamlanamadı.", "Deneme inceleniyor; inceleme bitene kadar fatura yeniden içeri alınamaz."],
};

const NOTICE = {
  LINE_VAT_DIFFERS_FROM_UBL: "Satır KDV'si faturadaki tutardan farklı hesaplandı.",
  LINE_NET_DIFFERS_FROM_UBL: "Satır tutarı faturadaki tutardan farklı hesaplandı.",
};

const SYSTEM_HINT = {
  CANDIDATE_INDEX_NOT_READY: "Ürün ve tedarikçi eşleştirmesi şu an kullanılamıyor.",
  CANDIDATES_INCOMPLETE: "Ürün ve tedarikçi eşleştirmesi şu an kullanılamıyor.",
  WAREHOUSE_INDEX_NOT_READY: "Depo listesi şu an kullanılamıyor.",
};
const SYSTEM_DEFAULT = "İçeri alma altyapısı bu fatura için henüz hazır değil.";

// {kind: fix|document|notice|system, text, step}.  Metin hiçbir zaman sunucu kodunu içermez.
export function classifyIssue(key) {
  if (FIX[key]) return { kind: "fix", step: FIX[key][0], text: FIX[key][1] };
  if (IMPORT_STATE[key]) return { kind: "state", text: IMPORT_STATE[key][0], hint: IMPORT_STATE[key][1] };
  if (DOCUMENT[key]) return { kind: "document", text: DOCUMENT[key] };
  if (NOTICE[key]) return { kind: "notice", text: NOTICE[key] };
  return { kind: "system", text: SYSTEM_HINT[key] || SYSTEM_DEFAULT };
}

export const EMPTY_CHOICE = { kind: null, product_id: null, new_product_draft: false, stock: null, vat_exemption_code: null };
const UNIT_FALLBACK = "Birim yok";

export function money(value, currency) {
  const text = formatDecimal(value);
  if (text == null) return "—";
  return `${text} ${currency === "TRY" ? "₺" : currency || ""}`.trim();
}

export function quantity(value, unit) {
  const text = formatDecimal(value, { minFraction: 0, trimZeros: true });
  if (text == null) return "—";
  return `${text} ${unit?.label || unit?.code || UNIT_FALLBACK}`;
}

export function payload(mode, lineChoices, createSupplier, supplierId, warehouseId) {
  return { mode, warehouse_id: mode === "expense_and_stock" ? warehouseId : null, supplier_id: supplierId,
    create_supplier: supplierId ? false : createSupplier, line_choices: lineChoices };
}

// Tüm kaynaklardaki kodlar tek listede: satır numarası korunur, aynı satırda aynı metin tekrarlanmaz.
export function collectIssues(decision, view) {
  const raw = [...(decision?.blocker_items || []), ...(decision?.review_items || [])].map((i) => ({ key: i?.key, line: Number.isInteger(i?.line_index) ? i.line_index : null }));
  for (const key of view?.document?.document_issues || []) raw.push({ key, line: null });
  for (const key of view?.supplier?.issues || []) raw.push({ key, line: null });
  for (const l of view?.lines || []) for (const key of l.issues || []) raw.push({ key, line: l.index });
  const supplierActionable = (view?.supplier?.candidates || []).length > 0 || view?.decisions?.supplier?.create_new?.available === true;
  const seen = new Set();
  const out = [];
  for (const { key, line } of raw) {
    let c = classifyIssue(key);
    // Seçecek aday yoksa "tedarikçiyi seçin" demek yanıltıcıdır: kullanıcıya düzeltme yükü bindirmeden sistem engeline düşer.
    if (c.kind === "fix" && c.step === 0 && /^SUPPLIER_/.test(String(key)) && !supplierActionable) c = { kind: "system", text: "Tedarikçi bu hesapta eşleştirilemedi." };
    const id = `${c.kind}|${line}|${c.text}`;
    if (seen.has(id)) continue;
    seen.add(id);
    out.push({ ...c, line });
  }
  return out;
}

export const PREVIEW_ERROR_TEXT = {
  rate: "Çok hızlı değişiklik yapıldı; birkaç saniye sonra yeniden deneyin.",
  server: "Sunucu şu an yanıt vermedi.",
  view: "Fatura satırları bu seçimle gösterilemedi.",
};
